// extracted by mini-css-extract-plugin
export default {"search-form":"SearchBox_search-form__afX+c","search-input":"SearchBox_search-input__niiRg","clear-icon":"SearchBox_clear-icon__7E3hY","search-icon":"SearchBox_search-icon__30k+4"};